import React from 'react';

import { ALTO } from '@constant/colors';

const Loading = () => (
  <svg viewBox="0 0 33 15">
    <path
      fill={ALTO}
      fillRule="evenodd"
      d="M25.883 15c2.336 0 4.143-.62 5.2-1.75.5-.538 1.056-1.44.64-2.12-.362-.592-.974-.705-1.697-.338-.723.367-1.585.565-2.502.565-1.585 0-3.225-1.328-3.225-3.248 0-.2.165-.17.388 0 .5.422 1.53.76 2.808.76C29.86 8.87 32 7.32 32 4.833 32 2.206 29.61.2 25.91.2c-4.14 0-7.394 2.655-7.394 7.23 0 4.265 2.67 7.57 7.367 7.57zM4.497 15c.973 0 1.418-.593 1.752-1.13l1.5-2.372c.306-.48.556-.735 1-.735.446 0 .696.255 1.002.735l1.5 2.372c.335.537.78 1.13 1.753 1.13.89 0 1.334-.395 1.723-1.214.64-1.384 1.25-2.966 1.89-5.48.585-2.344.78-3.844.863-5 .112-1.555-.194-2.487-1.695-2.77C13.672.142 11.753 0 8.75 0S3.83.14 1.718.537C.215.82-.09 1.75.02 3.305c.084 1.157.28 2.657.863 5 .64 2.515 1.25 4.097 1.89 5.48.39.82.834 1.215 1.724 1.215z"
    />
  </svg>
);

export default Loading;
